export const OPERATION_ERROR_CODE = {
    UID_BIND_EXIST: 18,
    KA_UID_BIND_EXIST: 10002,
}

export const CHANGE_TYPE = {
    OPENID: 'OEPNID',
    APPID: 'APPID',
}

export const SERVER_RES = {
    SUCCESS: 200,
}

export const ACCOUNT_TYPE_OF_BINDING = {
    YYB_AGENT: 1, // 应用宝代理
    TX_ADVERTISING_DELIVERY: 2, // 腾讯广告投放
}
